<template>
  <div>
    <NavbarComponent :routedata="adminNavBarRoutes.routes" v-if="user.role === 'ADMIN'" />
    <NavbarComponent :routedata="assigneeNavBarRoutes.routes" v-if="user.role === 'USER'" />
    <div class="entity-section">
      <router-view />
    </div>
  </div>
</template>

<script>
import { adminNavBarRoutes } from "../config/navigation-route";
import { assigneeNavBarRoutes } from "../config/navigation-route";

import NavbarComponent from "../components/NavbarComponent.vue";

import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("Auth");
export default {
  name: "AuthLayout",
  data() {
    return {
      adminNavBarRoutes,
      assigneeNavBarRoutes,
    };
  },
  components: {
    NavbarComponent,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
};
</script>

<style lang="scss" scoped>
.entity-section {
  padding: 20px;
  padding-top: 90px;
  min-height: 100vh;
  background-color: #f0f3f6;
}
</style>
